<mat-tab-group
	[selectedIndex]="getSelectedIndex()"
	(selectedTabChange)="onTabChange($event)"
	animationDuration="2000ms"
	mat-stretch-tabs="true"
>
	<mat-tab *ngFor="let tab of tabs; trackBy: trackByTab">
		<ng-template matTabLabel>
			{{ tab.label }}
		</ng-template>
	</mat-tab>
</mat-tab-group>
